import { createFileRoute } from "@tanstack/react-router";

import { RequirePermission } from "@/hooks/shared/CheckAuth";
import { MaintenanceFormPage } from "@/pages/dashboard/maintenance/form";

export const Route = createFileRoute("/_main/dashboard/maintenance/$id/edit")({
  component: () => (
    <RequirePermission action="maintenance.write">
      <MaintenanceFormPage />
    </RequirePermission>
  ),
});
